"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  mockApi: {
    baseUrl: 'http://localhost:4242'
  }
};